'use strict'

let endStageReport_fields=require('../../progress/labels/english_endStage.js').english_endStage;

export let english={
  log: {
    eventLog: "Event Log",
    logDescription : "Who did what, when? The event log is showing all events throughout the history of the activity. You can filter on content of the 'Event' column by entering a key word to filter on.",
    eventFilter : "Enter event filter",
    applyFilter : "Apply Filter",
    filterExamples : "E.g.: Add, Risk, Issue, Person, Role",
    filteredOn: "Event column now filtered on '",
    date: "Date",
    event: "Event",
    details: "Details",
    performedBy: "Performed by"
  },
  projectChanged: {
    types: {
      updatedProjectBackground: "Why is the project initiated?",
      updatedProjectTiming: "Why now?",
      updatedProjectBigPicture: "The bigger picture",
      changedProjectName: "name",
      changedProjectIdentifier: "identifier",
      changedProjectLocation: "location",
      changedProjectDepartment: "department",
      changedProjectPortfolio: "portfolio",
      changedProjectCategory: "category",
      changedProjectType: "project type",

      changedProgrammeName: "name",
      changedProgrammeIdentifier: "identifier",
      changedProgrammePortfolio: "portfolio",
      changedProgrammeLocation: "location",
      changedProgrammeDepartment: "department",
      updatedProgrammeBackground: "Justification and context",
      updatedProgrammeTiming: "Why now?",
      updatedProgrammeSuccessFactors: "Success Factors",

      updatedProjectCurrency: "Currency",

      changedProductName: "name",
      changedProductIdentifier: "identifier",
      changedProductPortfolio: "portfolio",
      changedProductDepartment: "department",
      changedProductLocation: "location",
      updatedProductDefinitionDescription: "description",
      updatedProductDefinitionBackground: "background",
      updatedProductDefinitionVision: "vision",

      changedReleasePortfolio: "portfolio",
      changedReleaseIdentifier: "identifier",

      unknownType: "(unknown)"
    },
    changed: "Changed",
    to: "to",
    previous: "previous value"
  },
  report: {
    highlight: {
      title : "Highlight Report",
      endStageReport: "End Stage Report",
      endProjectReport: "End Project Report",
      projectDeliverables: "Delivered by this project",
      summary: "Summary",
      benefits: "Benefits",
      time: "Time",
      cost: "Cost",
      quality : "Quality",
      scope: "Scope",
      risk: "Risk",
      currentPeriod : "This period",
      nextPeriod: "Next period",
      aspect: "Aspect",
      status: "Status",
      description: "Description",
      from: "from",
      issues: "Issues",
      draftSaved: "Draft saved",
      preview: "Preview",
      teamPerformance: "Team performance",
      lessonsDescription: "Lessons",
      undefinedDate: "<not defined>",
      deliveryStatus: endStageReport_fields.Overview.fields.performedAchivements.title,
      start: "Start",
      end: "End",
      managedBy: "Managed by",
      listLimitedTo: "In this report, the above list is limited to the",
      top5Risks: "top 5 risks",
      top5Issues: "top 5 issues"
    },
    issue: {
      title : "Issue Report",
      exceptionTitle: "Exception Report",
      impact: "Impact",
      type:"Issue Type",
      typeValues: {
        change: "Request for change",
        specification: "Off-specification",
        problem: "Problem / concern"
      },
      severity: "Severity",
      severityValues:["Undefined","Negligible","Minor","Moderate","Significant","Severe"],
      priority: "Priority",
      priorityValues:["Undefined","Very Low","Low","Medium","High","Very High"],
      options:"Options",
      recommendation:"Recommendation",
      lessonSummary: "Lessons",
      decision:"Decision",
      decidedBy: "Decision made by",
      status:"Status",
      closed:"Closed",
      active:"Active",
      previewGenerated: "Preview generated"
    }
  }
};



// WEBPACK FOOTER //
// ./views/log/labels/english.js